/**
 * 帮助中心目录编码
 */
export enum HelpCatalogueCode {
  /**
   * 竞拍流程
   */
  AUCTION_FLOW = 'AUCTION_FLOW',
  /**
   * 平台规则
   */
  PLATFORM_RULE = 'PLATFORM_RULE'
}

export const HelpCatalogueCodeTextMap = {
  [HelpCatalogueCode.AUCTION_FLOW]: '竞拍流程',
  [HelpCatalogueCode.PLATFORM_RULE]: '平台规则'
}
